import { render, staticRenderFns } from "./AppButtonAction.vue?vue&type=template&id=4a1a8fde&scoped=true&lang=pug&"
import script from "./AppButtonAction.vue?vue&type=script&lang=js&"
export * from "./AppButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonAction.vue?vue&type=style&index=0&id=4a1a8fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a8fde",
  null
  
)

export default component.exports